/**
 * Created by katarinababic on 11.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { WeekDayEntryWorkout } from '../../Model/Coach/Schedule/WeekDayEntryWorkout';
import { useRootStore } from '../../Store/useRootStore';
import { useLocalized } from '../../Hooks/useLocalized';
import { useTrans } from '../../Store/System/LocalizationStore';
import { StringUtils } from '../../Utils/StringUtils';
import { WorkoutDayCardEventListItem } from './WorkoutDayCardEventListItem';
import dayjs from 'dayjs';

export type WorkoutDayCardWorkoutProps = {
  entry: WeekDayEntryWorkout;
};

export const WorkoutDayCardWorkout: React.FC<WorkoutDayCardWorkoutProps> = observer(({ entry }) => {
  const { analytics } = useRootStore();
  const { t } = useTrans();
  const navigate = useNavigate();
  const workoutName = useLocalized(entry.workout.workout?.name);
  const programTitle = useLocalized(entry.workout.program?.template?.name);

  const microCycleDay = entry.workout;
  const program = entry.workout.program;
  const totalExerciseTime = microCycleDay.workout?.estimatedTotalExerciseTime ?? 0;
  const totalExerciseTimeText = totalExerciseTime
    ? t('globals.timeMin', { value: Math.round(totalExerciseTime / 60000) })
    : '-';

  const time = dayjs(entry.startTime).format('LT');

  const totalWeeks =
    program?.template && 'microCyclesCount' in program.template ? program.template.microCyclesCount : undefined;
  const currentWeek = (program?.currentWeekIndex ?? -1) + 1;

  const title = workoutName ? StringUtils.shortenString(workoutName, 40) : '';
  const programSubtitle =
    totalWeeks && currentWeek
      ? t('runningProgramsModal.currentWeek', {
          currentWeek,
          totalWeeks,
          defaultValue: 'Week {{currentWeek}} of {{totalWeeks}}',
        })
      : undefined;

  const subtitle = `${time} • ${totalExerciseTimeText ? `${totalExerciseTimeText} ` : ''}${t(
    'globals.workout',
  )}\n${programTitle}\n${programSubtitle}`;

  const handlePress = React.useCallback(() => {
    const workoutId = microCycleDay.coachWorkoutId || microCycleDay.workout?.id;
    if (workoutId) {
      analytics.logSelectContent('workout', workoutId);
      // Pass microCycleDayId in state for program workouts
      navigate(`/move/${workoutId}`, {
        state: {
          microCycleDayId: microCycleDay.id,
          workoutLogId: microCycleDay.workoutLog?.id,
        },
      });
    }
  }, [microCycleDay, analytics, navigate]);

  const handleLongPress = React.useCallback(() => {
    // TODO show skip alert
    // Alert.alert(t('workoutDayCard.skipAlert.title'), t('workoutDayCard.skipAlert.message'), [
    //     {
    //         text: t('workoutDayCard.skipAlert.skipButton'),
    //         style: 'destructive',
    //         onPress() {
    //             microCycleDay.skip();
    //         },
    //     },
    //     {
    //         text: t('workoutDayCard.skipAlert.cancelButton'),
    //     },
    // ]);
  }, []);

  if (microCycleDay.workout) {
    return (
      <WorkoutDayCardEventListItem
        title={title}
        subtitle={subtitle}
        onPress={handlePress}
        onLongPress={handleLongPress}
        disabled={microCycleDay.skipped}
        imageSource={
          microCycleDay.workout.largeWorkoutImage ? `url(${microCycleDay.workout.largeWorkoutImage.uri})` : undefined
        }
      />
    );
  }

  return null;
});
